var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #062860;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.72,14.52c-6.5-6.26-14.09-9.51-22.88-9.51H37.28c-8.91,0-16.5,3.25-22.76,9.51-6.26,6.26-9.51,13.85-9.51,22.76v225.56c0,8.79,3.25,16.5,9.51,22.88,6.26,6.26,13.85,9.27,22.76,9.27h225.56c8.79,0,16.38-3.01,22.88-9.27,6.26-6.38,9.27-14.09,9.27-22.88V37.28c0-8.91-3.01-16.5-9.27-22.76ZM127.48,222.02l-72.74-72.86,26.74-26.74,46,45.88,91.05-90.92,26.73,26.73-117.78,117.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDone);
export default __webpack_public_path__ + "static/media/icon_done.6a8e2e7e43150eefe2adf82b71a1a40c.svg";
export { ForwardRef as ReactComponent };